import React, { Dispatch, useContext, useState } from "react";
import { BASKET_TYPE_CHOICES, BOOKING_TYPES_CHOICES } from "../../components/Enumerators";
import { Notification } from "../../components/Notification";
import { Link, NavLink } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import CartClass from "../../classes/CartClass";
import RequestClass from "../../classes/RequestClass";
import { IInStore } from "../../interfaces/IProducts";

/*
  przycisk dodawania do koszyka albo zapytanie
  setIsClicked - event  informujący, że został wciśnięty przycisk
*/

const ToCartButton = (props: { inStore?: IInStore; className?: string; setIsClicked?: Dispatch<boolean> }) => {
    const [msg, setMsg] = useState<JSX.Element>();
    const { setBasketCnt, setInquiryCnt } = useContext(UserContext);
    // const navigate = useNavigate();

    /* bt - booking type */
    let label = props.inStore?.bookingType === BOOKING_TYPES_CHOICES.BOOKING_TYPE_ONLINE ? "Do koszyka" : "Wyślij zapytanie";

    function basket_order_callback(result: any) {
        setMsg(
            <Notification>
                {" "}
                Dodano do koszyka!
                <NavLink to="/koszyk">
                    <br />
                    Zobacz koszyk
                </NavLink>{" "}
            </Notification>
        );

        if (props.setIsClicked) {
            props.setIsClicked(true);
        }

        try {
            setBasketCnt(result.products.length);
        } catch (e) {
            console.log(e);
        }
    }
    // const location = useLocation();

    function basket_inquiry_callback(result: any) {
        setMsg(
            <Notification>
                Zobacz <Link to="/zapytanie">formularz zapytania</Link> lub kontynnuj i dodaj kolejne szkolenia.
            </Notification>
        );
        if (props.setIsClicked) {
            props.setIsClicked(true);
        }

        try {
            setInquiryCnt(result.products.length);
        } catch (e) {
            console.log(e);
        }

        // if(location.pathname.includes("/list/")) {
        //   // console.log(location.pathname.substring(location.pathname.length - 1))
        //   navigate("/inquiry/"+location.pathname.substring(location.pathname.length - 1));
        // } else {
        //   navigate("/inquiry");
        // }
        // setMsg(<Notification msg={<>Utworzono zapytanie<NavLink to="/zapytanie"><br/>Zobacz zapytanie</NavLink></>} lead="" />);
    }

    function basket_error_callback(result: any) {
        setMsg(RequestClass.errorAlert(result));
    }

    function action() {
        if (props.inStore?.productId !== undefined) {
            if (props.inStore.bookingType === BOOKING_TYPES_CHOICES.BOOKING_TYPE_ONLINE) {
                return CartClass.add(props.inStore.productId, 1, BASKET_TYPE_CHOICES.BASKET_ORDER, basket_order_callback, basket_error_callback);
            } else {
                /* WYŚLIJ ZAPYTANIE OFERTOWE */
                return CartClass.add(props.inStore.productId, 1, BASKET_TYPE_CHOICES.BASKET_INQUIRY, basket_inquiry_callback, basket_error_callback);
            }
        }
    }

    return (
        <>
            {msg !== undefined ? (
                msg
            ) : (
                <>
                    {props.inStore && (
                        <>
                            <button className={"p-2 button is-primary " + props.className} onClick={() => action()}>
                                {label}
                            </button>
                            {/* {msg} */}
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default ToCartButton;
